/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsMDRAlertsOverTime
 */
export interface JumboStructsMDRAlertsOverTime {
    /**
     * 
     * @type {number}
     * @memberof JumboStructsMDRAlertsOverTime
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsMDRAlertsOverTime
     */
    timestamp?: number;
}

/**
 * Check if a given object implements the JumboStructsMDRAlertsOverTime interface.
 */
export function instanceOfJumboStructsMDRAlertsOverTime(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsMDRAlertsOverTimeFromJSON(json: any): JumboStructsMDRAlertsOverTime {
    return JumboStructsMDRAlertsOverTimeFromJSONTyped(json, false);
}

export function JumboStructsMDRAlertsOverTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsMDRAlertsOverTime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
    };
}

export function JumboStructsMDRAlertsOverTimeToJSON(value?: JumboStructsMDRAlertsOverTime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'timestamp': value.timestamp,
    };
}

